export async function patchIfcForMocks(): Promise<void> {
  await import('./ifc-onecore.mock');
}
